var setImmediate = typeof global !== 'undefined' && typeof global.setImmediate !== 'undefined' ? global.setImmediate : setTimeout;

export default setImmediate;


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-persist/es/utils/setImmediate.js
// module id = 2156
// module chunks = 25